import {
  BrowserRouter,
  Route,
  Routes as ReactRouterRoutes,
} from 'react-router-dom';

import { Loader } from '@hivebrite/design-system/Loader';

import { NewsIndexClient } from 'hb-react/frontoffice/apps/NewsIndex/startup/NewsIndexClient';
import {
  type Config,
  type NewsIndexClientStandaloneProps,
} from 'hb-react/frontoffice/apps/NewsIndex/types';
import PublicOfficeApp from 'hb-react/publicoffice/providers/App';
import { EvolutionTeamErrorBoundary } from 'hb-react/shared/components/ErrorBoundary';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';
import { getNewsIndexPath } from 'hb-react/shared/utils/news/newsPaths';

// TODO: Once we cleanup flagEvNewsRevamp, we can merge back the two components into one.
const NewsIndexClientStandaloneRoutes = ({ page }: { page: any }) => {
  const { flagEvNewsRevamp, flagsLoaded } = useFeatureFlag();

  const config: Config = {
    routes: {
      news_url: flagEvNewsRevamp
        ? getNewsIndexPath()
        : Routes.network_letters_path({
            format: 'json',
          }),
      categories_url: Routes.network_news_categories_json_path(),
    },
    custom: {
      page,
    },
  };

  if (!flagsLoaded) {
    return <Loader />;
  }

  return (
    <BrowserRouter>
      <ReactRouterRoutes>
        <Route element={<NewsIndexClient config={config} />} path={'/news/*'} />
      </ReactRouterRoutes>
    </BrowserRouter>
  );
};

const NewsIndexClientStandalone = ({
  network,
  page,
}: NewsIndexClientStandaloneProps) => (
  <EvolutionTeamErrorBoundary app="po" module="news_index">
    <PublicOfficeApp network={network}>
      <NewsIndexClientStandaloneRoutes page={page} />
    </PublicOfficeApp>
  </EvolutionTeamErrorBoundary>
);

export default NewsIndexClientStandalone;
